import { ColorCode } from '../shared/constants';

export const SAMPLE_HISTORY_CSV_TEMPLATE = `Product Quantity,UOM,Product Manufacturer Name,Product Manufacturer ERP Code,Product Model Number,Product ERP Code,Product Description,Product Cost,Product Margin,Product Sell Price,Per,Product Lead Time Value/Range,Product Lead Time Unit,Project Manufacturer Sales Agent Name,Project Manufacturer Sales Agent ERP Code,Source Quote Number,Quote ERP ID,Quote Location Name,Quote Location ERP ID,Quote Status,Quote Due Date/Time,Quote Creation Date/Time,Quote Creator Name,Quote Creator ERP ID,Quote Owner Name,Quote Owner ERP ID,Outside Sales Name,Outside Sales ERP ID,Customer Name,Customer DUNS #,Customer CRM ID,Customer ERP ID,Project Stakeholder 1 Name,Project Stakeholder 1 DUNS #,Project Stakeholder 1 CRM ID,Project Stakeholder 1 ERP ID,Project Stakeholder 2 Name,Project Stakeholder 2 DUNS #,Project Stakeholder 2 CRM ID,Project Stakeholder 2 ERP ID,Project Stakeholder 3 Name,Project Stakeholder 3 DUNS #,Project Stakeholder 3 CRM ID,Project Stakeholder 3 ERP ID,Project Stakeholder 4 Name,Project Stakeholder 4 DUNS #,Project Stakeholder 4 CRM ID,Project Stakeholder 4 ERP ID,Project Stakeholder 5 Name,Project Stakeholder 5 DUNS #,Project Stakeholder 5 CRM ID,Project Stakeholder 5 ERP ID,Project Name,Project ERP ID,Project Market Vertical,Project Construction Scope,Project Square Footage (sqft),Project Address Line 1,Project Address Line 2,Project Country,Project City,Project State,Project Zip Code
Quantity of the product quoted,Unit of measure of the product quoted. Will default to EA (Each) if left empty.,Name of the Manufacturer of the product quoted,ERP Code of the manufactuer of the product quoted,Model number of the product quoted,Product ERP code of the product quoted,Description of the product quoted,Cost of the product quoted,Margin of the product quoted,Sell price of the product quoted,"Quantity corresponding to the product cost and product sell price. Accepted Entries: '1'; '100', '1000'. Will default to '1' if left empty. ","Lead Time Value or Range of the product quoted. Accepted Formats: integer, or two integers separated by '-'",Unit for the lead time value/range of the product quoted. Accepted Entries: 'In Stock'; 'Days'; 'Working Days'; 'Weeks'; 'Months'; 'Years';'-'. Will default to '-' if left empty.,Company name of the manufacturer sales agent associated with the quoted the product,CRM/ERP ID of the manufacturer sales agent associated with the quoted the product,Source quote number of line item (Project Manufacturer Sales Agent Quote# or Manufacturer Quote#).,ERP ID of the quote in which the product was quoted.,Name of the branch location that quoted the product,ERP ID of the branch location that quoted the product,Status of the quote in which this product was in. Accepted Entries: 'Won'; 'Lost'; 'Abandoned'; '-'. Will default to '-' if left empty.,Date and time at which the quote was due for that product. Accepted Formats: 'mm/dd/yyyy  hh:mm:ss',Date and time at which the product was quoted. Accepted Formats: 'mm/dd/yyyy  hh:mm:ss',First_Name and Last_Name of the user who generated the quote document associated with the quoted product,ERP ID of the user who generated the quote document associated with the quoted product,First_Name and Last_Name of the user assigned as the quote owner of the project this product was quoted for,ERP ID of the user assigned as the quote owner of the project this product was quoted for,First_Name and Last_Name of the outside sales agent (internal to your company) associated with the quoted the product,CRM/ERP ID of the outside sales agent (internal to your company) associated with the quoted the product,Company name of the primary customer this product was quoted for,Company DUNS # of the customer this product was quoted for,Company CRM ID of the customer this product was quoted for,Company ERP ID of the customer this product was quoted for,"Company name of the stakeholder 1 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company DUNS # of the stakeholder 1 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company CRM ID of the stakeholder 1 this product was quoted for..
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company ERP ID of the stakeholder 1 this product was quoted for..
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company name of the stakeholder 2 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company DUNS # of the stakeholder 2 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company CRM ID of the stakeholder 2 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company ERP ID of the stakeholder 2 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company name of the stakeholder 3 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company DUNS # of the stakeholder 3 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company CRM ID of the stakeholder 3 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company ERP ID of the stakeholder 3 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company name of the stakeholder 4 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company DUNS # of the stakeholder 4 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company CRM ID of the stakeholder 4 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company ERP ID of the stakeholder 4 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company name of the stakeholder 5 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company DUNS # of the stakeholder 5 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company CRM ID of the stakeholder 5 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ","Company ERP ID of the stakeholder 5 this product was quoted for.
Relevant project stakeholder such as lighting designer, engineer, architect, owner, municipality, etc. ",Name of the project this product was quoted for,ERP ID of the project this product was quoted for,Market vertical of the project this product was quoted for.  Accepted Entries: 'Multi-Family Apartment'; 'Multi-Family Condo'; 'Resort'; 'Retail'; 'Commercial Core + Shell': 'Commercial Tenant Improvement'; 'Single Bldg Residential'; 'Healthcare'; 'Multi-Bldg Residential'; 'Industrial'; 'Roadway'; 'Site'; 'Government'; 'K-12'; 'Higher Education'; 'Religious'; 'Judicial';,"Construction scope of the project this product was quoted for.
 Accepted Entries: 'Renovation'; 'New Construction'",Square footage of the project this product was quoted for. Accepted Formats: Integer.,Address Line 1 of the project this product was quoted for.,Address Line 1 of the project this product was quoted for.,"Country of the project this product was quoted for.
 Accepted Entries: 'USA'; 'CANADA'",City  of the project this product was quoted for.,"State code of the project this product was quoted for.
Accepted formats: Two letter state abbrevation (ex: CA, NY, etc.) ",Zip code of the project this product was quoted for.
15,EA,LITHONIA,LITH124,LDN6-80-50-34,1234567890,product long description,$100.00,20.00%,$125.00,1,4,Days,RadiantRep Solutions,24786,8657,76578,Parspec North California,1234,Lost,12/30/2024 14:00,12/30/2024 14:00,Emily Davis,4321,Emily Davis,4321,Sophie Bennett,24786,BrightWave Electrical,32466,32466,32466,BrightWave Electrical,32466,32466,32466,BrightWave Electrical,32466,32466,32466,BrightWave Electrical,32466,32466,32466,BrightWave Electrical,32466,32466,32466,BrightWave Electrical,32466,32466,32466,Riverbend Commercial Complex,7658,Retail,Renovation,100000,324 Oak Street,Building A,USA,Sacramento,CA,94202
10,EA,LITHONIA,LITH124,LDN6-80-50-34,1234567890,product long description,$100.00,20.00%,$125.00,1,8-10,Weeks,LumiLink Associates,94872,7869,78659,Parspec South California,4321,Won,10/20/2024 15:20,10/20/2024 15:20,John Smith,1234,John Smith,1234,Liam Harris,94872,VoltPro Electrical Solutions,24622,24622,24622,VoltPro Electrical Solutions,24622,24622,24622,VoltPro Electrical Solutions,24622,24622,24622,VoltPro Electrical Solutions,24622,24622,24622,VoltPro Electrical Solutions,24622,24622,24622,VoltPro Electrical Solutions,24622,24622,24622,Skyline Heights Development,7688,Healthcare,New Construction,100000,325 Bark Street,Building B,USA,Sacramento,CA,94202`;
export const DELETE_IMPORTED_RECORDS_TITLE = 'Delete Imported Record(s)';

export const PRICING_HISTORY_TABLE_COLUMN_OPTIONS = {
    data: [
        {
            label: 'Source',
            field: 'source'
        },
        {
            label: 'Date Uploaded',
            field: 'dateUploaded'
        },
        { label: 'Edited On', field: 'editedOn' },
        {
            label: 'Edited By',
            field: 'editedBy'
        },
        { label: 'Qty', field: 'qty' },
        { label: 'UOM', field: 'uom' },
        { label: 'Manufacturer', field: 'manufacturer' },
        {
            label: 'Model Number',
            field: 'modelNumber'
        },
        { label: 'Description', field: 'description' },
        {
            label: 'Cost',
            field: 'cost'
        },
        {
            label: 'Per',
            field: 'per'
        },
        {
            label: 'Discount (%)',
            field: 'discount'
        },
        {
            label: 'Discounted Cost',
            field: 'discountedCost'
        },
        {
            label: 'Margin (%)',
            field: 'margin'
        },
        {
            label: 'Sell Price',
            field: 'sellPrice'
        },
        {
            label: 'Lead time Value',
            field: 'leadTimeValue'
        },
        { label: 'Lead time Unit', field: 'leadTimeUnit' },
        {
            label: 'Project',
            field: 'projectName'
        },
        {
            label: 'Project Stage',
            field: 'projectStage'
        },
        {
            label: 'Branch Location',
            field: 'branchLocation'
        },
        { label: 'Source Quote Number', field: 'sourceQuoteNumber' },
        {
            label: 'Quote Owner',
            field: 'quoteOwner'
        },
        {
            label: 'BOM',
            field: 'bomName'
        },
        {
            label: 'Primary Customer',
            field: 'primaryCustomerName'
        },
        {
            label: 'Secondary Customer',
            field: 'secondaryCustomerName'
        },
        {
            label: 'Quote Status',
            field: 'quoteStatus'
        },
        {
            label: 'Outside Sales',
            field: 'salesAgent'
        },
        {
            label: 'Qty',
            field: 'qty'
        },
        {
            label: 'Product ERP Code',
            field: 'productErpCode'
        },
        {
            label: 'Quote ERP ID',
            field: 'quoteErpId'
        },
        {
            label: 'Quote Due Date',
            field: 'quoteDueDate'
        },
        {
            label: 'Quote Creation Date',
            field: 'quoteCreationDate'
        },
        {
            label: 'Quote Creator',
            field: 'quoteCreator'
        },
        {
            label: 'Stakeholder 1',
            field: 'stakeHolder1'
        },
        {
            label: 'Stakeholder 2',
            field: 'stakeHolder2'
        },
        {
            label: 'Stakeholder 3',
            field: 'stakeHolder3'
        },
        {
            label: 'Stakeholder 4',
            field: 'stakeHolder4'
        },
        {
            label: 'Stakeholder 5',
            field: 'stakeHolder5'
        },
        {
            label: 'Project ERP ID',
            field: 'projectErpId'
        },
        {
            label: 'Market Vertical',
            field: 'projectMarketVertical'
        },
        {
            label: 'Construction Scope',
            field: 'projectConstructionScope'
        },
        {
            label: 'Square feet(sqft)',
            field: 'projectFootage'
        },
        {
            label: 'Address Line 1',
            field: 'addressLine1'
        },
        {
            label: 'Address Line 2',
            field: 'addressLine2'
        },
        {
            label: 'Country',
            field: 'projectCountry'
        },
        {
            label: 'State',
            field: 'projectState'
        },
        {
            label: 'City',
            field: 'projectCity'
        },
        {
            label: 'Zip Code',
            field: 'projectZip'
        }
    ]
};

export const PARSPEC_RECORD_TOOLTIP_INFO = 'Parspec quoted records cannot be deleted';
export enum PROJECT_SOURCE_LABEL_ENUM {
    PARSPEC = 'Parspec',
    IMPORT = 'Import'
}
export const SOURCE_TO_COLOR_MAP = {
    [PROJECT_SOURCE_LABEL_ENUM.IMPORT]: 'success',
    [PROJECT_SOURCE_LABEL_ENUM.PARSPEC]: 'tertiary'
};
export const PROJECT_SOURCE_OPTIONS = [
    { label: PROJECT_SOURCE_LABEL_ENUM.PARSPEC, value: 'Parspec', type: 'tertiary' },
    { label: PROJECT_SOURCE_LABEL_ENUM.IMPORT, value: 'Import', type: 'success' }
];

export const PROJECT_SOURCE_OPTIONS_MAP = PROJECT_SOURCE_OPTIONS.reduce((currMap, projSource) => {
    currMap[projSource.value] = projSource.label;
    return currMap;
}, {} as Record<string, string>);

export const getSourceColor = (source: string) => {
    return SOURCE_TO_COLOR_MAP[source as keyof typeof SOURCE_TO_COLOR_MAP] as ColorCode;
};
export const FIXED_COL_SET = new Set(['source']);
export const PRICING_HISTORY_COL_DEF = [
    { rowDrag: true, width: 10, maxWidth: 50, resizable: false, editable: false },
    {
        headerCheckboxSelection: true,
        width: 50,
        maxWidth: 50,
        resizable: false,
        showDisabledCheckboxes: true,
        checkboxSelection: (params: any) => {
            return !FIXED_COL_SET.has(params.data.field);
        }
    },
    {
        field: 'label',
        minWidth: 100,
        headerName: 'Column Name'
    }
];
